import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the GeocodingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GeocodingProvider {

  constructor(public http: HttpClient) {
    console.log('Hello GeocodingProvider Provider');
  }
  // NOMINATIM API
  // Docs : http://nominatim.org/release-docs/latest/api/Search/
  
  searchAddress(query){
    return new Promise(resolve => {
      let url = "https://nominatim.openstreetmap.org/search?q=" + encodeURI(query) + "&format=json&addressdetails=1&countrycodes=fr";

      console.log("searchAddress url :", url);
      this.http.get(url).subscribe(
        data => {
          console.log("searchAddress data", data);
          resolve(data);
        },
        error => {
          console.log(error.status);
          console.log(error.error); // error message as string
          console.log(error.headers);
        }
      );
    });
  }
  // REST API
  // Base query is the search for a place with a string. It returns 20 results matching query word.

  // https://geocoder.tilehosting.com/q/[query].js?key=xRogQtC5Ngo15znlQhAI
  // Reverse geocoding
  // This endpoint transfers a location point (latitude, longitude) to a readable address or place name:

  // https://geocoder.tilehosting.com/r/[longitude]/[latitude].js?key=xRogQtC5Ngo15znlQhAI
  // Country specific search
  // Country specific search for autocomplete. This endpoint returns 20 results matching the within a specific country, identified by the (lowercase ISO 3166 Alpha-2 code).

  // https://geocoder.tilehosting.com/[country_code]/q/[query].js?key=xRogQtC5Ngo15znlQhAI

  // Example
  // For example search for "Zurich" with

  // https://geocoder.tilehosting.com/q/zurich.js?key=xRogQtC5Ngo15znlQhAI

  searchAddressOld(query){
    return new Promise(resolve => {
      console.log("searchAddress query :", query);
      let url = "https://geocoder.tilehosting.com/FR/q/" + encodeURI(query) + ".js?key=xRogQtC5Ngo15znlQhAI";

      console.log("searchAddress url :", url);
      this.http.get(url).subscribe(
        data => {
          console.log("searchAddress data", data["results"]);
          resolve(data["results"]);
        },
        error => {
          console.log(error.status);
          console.log(error.error); // error message as string
          console.log(error.headers);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/geocoding/geocoding.provider.ts